import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicContractorDto extends EpimsBaseEntityDto {

    ContractorName: string;
    Address: string;
    PhoneNo: string;
    Email: string;
    VendorNo: string;
    Website: string;
    SubscriberId: string;
    SiteId: string;

}